// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"73f8b8fc","154":"25e27ba0","178":"6a9af7f4","205":"6aee8e68","338":"e59223f1","442":"6407ff1e","458":"9e2819bd","513":"3a277327","703":"aa70bcaa","712":"fab732b4","729":"4933e8d6","772":"97e35f4f","879":"a18250b0"}[chunkId] + ".chunk.js";
};